import './Chord-d4edcc89.css';

var classes = {"Chord":"prc-components-Chord-vlqS5","ChordNormal":"prc-components-ChordNormal-6rvP6","ChordOnEmphasis":"prc-components-ChordOnEmphasis-XDov-","ChordOnPrimary":"prc-components-ChordOnPrimary--7rmy","ChordSmall":"prc-components-ChordSmall-nDiio"};

export { classes as default };
